import { supabase as sharedSupabase } from "../../../auth/supabaseClient";

export const churchSupabase = sharedSupabase;
export const supabase = sharedSupabase;
